// extracted by mini-css-extract-plugin
export default {"container":"Bg_container__CtmPq","videoScale":"Bg_videoScale__CpA-g"};